import React from 'react';
import {
  isChunkLoadError,
  reloadForStaleChunks,
} from '../utils/chunkLoadRecovery';

/**
 * Error Boundary to catch render errors in the tree. On error, renders nothing
 * (blank section) and logs the error to console for debugging.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (isChunkLoadError(error)) {
      reloadForStaleChunks();
      return;
    }
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
